var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"grey lighten-4"},[_c('v-content',{staticClass:"mx-4 pt-6"},[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1),(_vm.rendered)?_c('drawer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }